/* eslint-disable eqeqeq */
import BackendLayout from "../../layouts/BackendLayout";
import {useDispatch, useSelector} from "react-redux";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {
  SEARCH_INSPECTION_HISTORY_CONFIRM,
  SEARCH_INSPECTION_HISTORY_RESULT,
  SEARCH_INSPECTION_HISTORY_CORRECTION
} from "../../constants/routes";
import CustomSpan from "../../components/CustomSpan";
import React, {useEffect, useRef, useState} from "react";
import {useParams, useLocation, useNavigate} from "react-router-dom";
import {getSearchInspectionHistoryResultSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import {getInformationInspection, submitInformationInspection, cancelInspection} from "../../services/search/InspectionHistoryConfirm";
import {errorStatusHandle, getSearchBackUrl} from "../../utils";
import {useDocumentTitle, useFileDownloader, useTableInspectionItemsScroll} from "../../hooks";
import {PageTitle} from "../../components/admin";
import Table from "../../components/table/Table";
import {
  Label,
  FormGroupInput,
  RemarkDetail,
  ButtonBack,
  ButtonUpdate,
  ButtonDownloadFile,
  TreatmentContent,
  JudgmentContent,
  InspectionInformationTable,
  JudgmentStatus,
  ButtonDPad,
  JudgmentLimit,
  InspectionResultWithUnit,
  ButtonCancel,
  Button, RedirectAlert
} from "../../components";
import {
  resetAlert,
  setInspectionConfirmAlertError,
  setButtonProcessing,
  clearButtonProcessing,
  clearPageLoading,
  setPageLoading
} from "../../store/actions";
import PageAlert from '../../components/alerts/PageAlert';
import {formatDateTime} from "../../utils/datetime-utils";
import {API_EXPORT_INSPECTION_CONFIRM} from "../../constants/api";
import {HTTP_ERROR_CODES} from "../../constants/error";
import {
  BUTTON_EXPORT_INSPECTION_CONFIRM,
  BUTTON_NEXT_INSPECTION_CONFIRM,
  BUTTON_CANCEL_INSPECTION
} from "../../constants/buttons";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getInspectionResutlSymbol,
  getInspectionUnit
} from "../../utils/display-utils";
import ExpandablePanel from "../../components/ExpandablePanel";
import ReadonlyComment from "../../components/ReadonlyComment"
import {Modal} from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

import {SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";


export default function InspectionHistoryConfirmPage() {
  useRedirectPage(SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE);
  const {downloadFileFromPath} = useFileDownloader();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {workflowId, inspectionId} = useParams();
  const location = useLocation();
  const searchParams = location.state?.searchParams || {};
  const in_url = location.state?.in_url || false;
  const [inspection, setInspection] = useState({});
  const [treatment, setTreatment] = useState({});
  const [judgmentStatus, setJudgmentStatus] = useState(null);
  const [group, setGroup] = useState({});
  const [defaultParams, setDefaultParams] = useState({});
  const [inspectionResult, setInspectionResult] = useState([]);
  const [inspectionItem, setInspectionItem] = useState([]);
  const [openModalCancel, setOpenModalCancel] = useState(false);
  const [formRegister, setFormRegister] = useState({});
  const [judgments, setJudgments] = useState([]);
  const tableInspectionRef = useRef(null);
  const maxHeightTableInspection = useTableInspectionItemsScroll(tableInspectionRef, inspectionItem);


  const resultField = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_field
  );
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const formatDisplayUser = (user) => {
    return `${user.name} (${user.username})`
  };

  useEffect(() => {
    setInspectionHistoryConfirmPageSettings(workflowId, inspectionId, searchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowId, inspectionId]);

  const handleDownload = () => {
    dispatch(setButtonProcessing(BUTTON_EXPORT_INSPECTION_CONFIRM));
    downloadFileFromPath(API_EXPORT_INSPECTION_CONFIRM(workflowId, inspectionId)).finally(() => {
      dispatch(clearButtonProcessing(BUTTON_EXPORT_INSPECTION_CONFIRM))
    });
  };

  const setInspectionHistoryConfirmPageSettings = async (workflowId, inspectionId, searchParams) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getSearchInspectionHistoryResultSettings();
      dispatch(setPageSettings(pageSettings));

      const informationInspection = await getInformationInspection(workflowId, inspectionId, searchParams);
      const inspection = informationInspection.data.inspection;
      setJudgments(informationInspection.data.judgments);
      setInspection(inspection);
      setTreatment(inspection.inspection_treatment);
      setGroup(informationInspection.data.list_group);
      setJudgmentStatus(informationInspection.data.judgment_status);
      setDefaultParams(informationInspection.data.default_params);
      setInspectionResult(informationInspection.data.inspection.result_inspection);
      setInspectionItem(informationInspection.data.inspection.inspection_item);

      const updatedFormRegister = Object.keys(resultField).reduce((acc, key) => {
        if (key.toLowerCase().includes("datetime")) {
          acc[key] = inspection[key] ? formatDateTime(new Date(inspection[key])) : '-';
        }
        if (key === 'inspection_start_user_id') {
          acc[key] = formatDisplayUser(inspection['inspection_start_user'])
        }
        if (key === 'operation_start_user_id') {
          acc[key] = inspection['operation_start_user'] ? formatDisplayUser(inspection['operation_start_user']) : '-'
        }
        return acc
      }, {...formRegister});

      setFormRegister(updatedFormRegister);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  const handleButtonBack = (message=null) => {
    dispatch(resetAlert());
    if (message !== null) {
      localStorage.setItem('cancel_message', message);
    }
    if (Object.keys(searchParams).length === 0 && in_url != true) {
      navigate(getSearchBackUrl(defaultParams, '', SEARCH_INSPECTION_HISTORY_RESULT), {state: defaultParams})
    } else {
      navigate(getSearchBackUrl(searchParams, '', SEARCH_INSPECTION_HISTORY_RESULT), {state: searchParams})
    }
  };

  const handleRedirect = async () => {
    dispatch(setButtonProcessing(BUTTON_NEXT_INSPECTION_CONFIRM));
    try {
      await submitInformationInspection(workflowId, inspectionId, searchParams);
      dispatch(resetAlert());
      if (Object.keys(searchParams).length === 0) {
        navigate(SEARCH_INSPECTION_HISTORY_CORRECTION.replace(':workflowId', workflowId).replace(':inspectionId', inspectionId));
      } else {
        navigate(SEARCH_INSPECTION_HISTORY_CORRECTION
          .replace(':workflowId', workflowId)
          .replace(':inspectionId', inspectionId), {state: {searchParams: searchParams, in_url: true}});
      }
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setInspectionConfirmAlertError(responseData));
      }
    } finally {
      dispatch(clearButtonProcessing(BUTTON_NEXT_INSPECTION_CONFIRM))
    }
  };

  const handleNavigateBreadcrumb = () => {
    navigate(getSearchBackUrl(searchParams, '', SEARCH_INSPECTION_HISTORY_RESULT), {state: searchParams})
  };

  const breadcrumb = getPageBreadcrumb(SEARCH_INSPECTION_HISTORY_CONFIRM, handleNavigateBreadcrumb);
  const handleCancelInspection = async () => {
    dispatch(setButtonProcessing(BUTTON_CANCEL_INSPECTION));
    try {
      const response = await cancelInspection(inspectionId);
      dispatch(resetAlert());
      handleButtonBack(response.success_message)
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setInspectionConfirmAlertError(responseData));
      }
    } finally {
      dispatch(clearButtonProcessing(BUTTON_CANCEL_INSPECTION));
      setOpenModalCancel(false);
    }
  };

  useDocumentTitle("点検履歴 - 点検王");
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <ButtonDPad />
      <div className="w-full flex flex-col justify-start gap-[16px] flex-1"
           id="top_scroll">
        <PageTitle title="点検履歴" className="!mb-0"/>
        <RedirectAlert className="!mb-0" />
        <PageAlert className="!mb-0"/>
        <div className="flex flex-col w-full max-w-[1674px] min-w-[1120px]">
          <div className="flex justify-end space-x-[24px] mb-[12px] lg:pr-0 pr-6">
            <ButtonCancel className="min-w-[180px]" onClick={() => setOpenModalCancel(true)}>
              <span>点検キャンセル</span>
            </ButtonCancel>
            <ButtonUpdate id={BUTTON_NEXT_INSPECTION_CONFIRM} onClick={() => handleRedirect()}
                          className="min-w-[180px]">
              <span>修正する</span>
            </ButtonUpdate>
            <ButtonDownloadFile id={BUTTON_EXPORT_INSPECTION_CONFIRM} onClick={() => handleDownload()}/>
          </div>
          <div className='flex flex-col xl:gap-[32px] gap-[28px] lg:pr-0 pr-6'>
            <div className="flex gap-[20px] items-stretch">
              <InspectionInformationTable inspection={inspection} group={group}/>
              <JudgmentStatus judgmentStatus={judgmentStatus} workflowId={workflowId} inspectionId={inspectionId}/>
            </div>
            <ExpandablePanel title="点検結果">
              <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                maxHeight: maxHeightTableInspection ? `${maxHeightTableInspection}px` : "auto"
              }} ref={tableInspectionRef}>
                <Table className="no-drop-shadow-table" striped>
                  <Table.Head className={`${maxHeightTableInspection ? 'sticky top-0 z-[8]' : ''} border-b border-tenken-gray-200`}>
                    <Table.HeadCell className="!normal-case w-[76px] scrollable-table-header-bg">
                      <span>No.</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="max-w-[938px] scrollable-table-header-bg">
                      <span className="whitespace-nowrap">点検項目</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="scrollable-table-header-bg">
                      <span className="whitespace-nowrap">判定基準</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="scrollable-table-header-bg">
                      <span className="whitespace-nowrap">下限</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="scrollable-table-header-bg">
                      <span className="whitespace-nowrap">上限</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="scrollable-table-header-bg"></Table.HeadCell>
                    <Table.HeadCell className="scrollable-table-header-bg">
                      <span className="whitespace-nowrap">留意事項</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="scrollable-table-header-bg">
                      <span className="whitespace-nowrap">点検結果</span>
                    </Table.HeadCell>
                  </Table.Head>
                  <Table.Body className="devide-y text-base break-all">
                    {inspectionItem && inspectionItem.length > 0 ? (
                      inspectionItem.map((item, index) => (
                        <Table.Row key={index}
                                   className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                          <Table.Cell>
                            <span>{item.item_order}</span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[400px]">
                            <span
                              style={{color: item.title_color}}
                              className="break-all"
                            >
                              {item.title}
                            </span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <span
                              style={{color: item.description_color}}
                              className="break-all"
                            >
                              {item.description}
                            </span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_judgment?.lower_value}
                              boundaryType={item.inspection_judgment?.lower_boundary_type}
                              unit={item.unit}
                              type="lower"
                            />
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_judgment?.upper_value}
                              boundaryType={item.inspection_judgment?.upper_boundary_type}
                              unit={item.unit}
                              type="upper"
                            />
                          </Table.Cell>
                          <Table.Cell className="px-2">
                            <CustomSpan
                              title={item.unit}
                              className="whitespace-nowrap"
                            >
                              {item.unit ? getInspectionUnit(item.unit, true) : '-'}
                            </CustomSpan>
                          </Table.Cell>
                          <Table.Cell>
                            <RemarkDetail key={index} rowData={item}/>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            {(() => {
                              const foundResult = inspectionResult.find(
                                (isResult) => isResult.inspection_item_id === item.id
                              );
                              return foundResult ? (
                                <>
                                  <span
                                        style={{
                                          color: getInspectionResutlColor(
                                            foundResult.result,
                                            resultSymbolSetting
                                          ),
                                          background: getInspectionResutlBackground(
                                            foundResult.result,
                                            resultSymbolSetting
                                          ),
                                        }}>
                                      {getInspectionResutlSymbol(
                                        foundResult.result,
                                        resultSymbolSetting,
                                      )}
                                  </span>
                                  {item.inspection_item_type?.name == 'input' && (
                                    <InspectionResultWithUnit
                                      inspectionResult={foundResult.inspection_item_value}
                                      unit={item.unit}
                                      className="ml-1"
                                    />
                                  )}
                                </>
                              ) : (
                                <span
                                  style={{
                                    color: getInspectionResutlColor(
                                      null,
                                      resultSymbolSetting
                                    ),
                                    background: getInspectionResutlBackground(
                                      null,
                                      resultSymbolSetting
                                    ),
                                  }}>
                                      {getInspectionResutlSymbol(
                                        null,
                                        resultSymbolSetting,
                                      )}
                                  </span>
                              );
                            })()}
                          </Table.Cell>
                        </Table.Row>
                      ))
                    ) : (
                      null
                    )}
                  </Table.Body>
                </Table>
              </div>
              <div className="relative rounded-lg border border-[#e0e0e0] w-full">
                <Table className="no-drop-shadow-table" striped>
                  <Table.Head className="whitespace-nowrap border-b border-tenken-gray-200">
                    <Table.HeadCell
                      className="w-[40%] !bg-white"
                    >
                      <span>点検者情報</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="!bg-white">
                    </Table.HeadCell>
                  </Table.Head>
                  <Table.Body className="devide-y text-base whitespace-nowrap">
                    {resultField && Object.keys(resultField).length > 0 ? (
                      Object.entries(resultField).map(([key, title], index) => (
                        key != 'registration_datetime' && (
                          <Table.Row key={index}
                                     className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                            <Table.Cell>
                              <span className="tenken__text-gray-900">{title}</span>
                            </Table.Cell>
                            <Table.Cell>
                              <FormGroupInput className="!flex-col">
                                <FormGroupInput className="gap-[20px]">
                                  <CustomSpan text={formRegister[key]} />
                                </FormGroupInput>
                              </FormGroupInput>
                            </Table.Cell>
                          </Table.Row>
                        )
                      ))
                    ) : (
                      null
                    )}
                  </Table.Body>
                </Table>
              </div>
              <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                <Label className="font-medium" text="点検コメント"/>
                <ReadonlyComment
                  remarkText={inspection?.remark_text}
                  commentFiles={inspection?.inspection_comment_files}
                />
              </div>
            </ExpandablePanel>
            <TreatmentContent treatments={treatment} inspectionItem={inspectionItem} inspection={inspection}/>
            <JudgmentContent judgments={judgments}/>
          </div>
        </div>
        <div className="flex items-center p-[10px] justify-center"
             id="end_scroll">
          <ButtonBack onClick={() => handleButtonBack()}/>
        </div>
        <Modal show={openModalCancel} onClose={() => setOpenModalCancel(false)} size="md" className="z-[9999] ">
          <Modal.Header className="px-[24px] py-[12px]">
            点検キャンセル
          </Modal.Header>
          <Modal.Body className="px-[24px] lg:text-[16px] text-[15px]">
            点検履歴を削除します。 <br></br>
            本当によろしいですか？
          </Modal.Body>
          <Modal.Footer className="space-x-[32px] h-[80px] flex justify-center">
            <Button type="submit" theme={tenkenTheme.button} color="gray" onClick={() => setOpenModalCancel(false)}
                    className="rounded-lg border !min-w-[180px]">
              戻る
            </Button>
            <Button type="submit" id={BUTTON_CANCEL_INSPECTION} theme={tenkenTheme.button}  onClick={() => handleCancelInspection()} color="primary" className="rounded-lg border !min-w-[180px]">
              点検履歴を削除
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </BackendLayout>
  );
}
